module.exports = __webpack_public_path__ + "img/goods05.7f2f6b50.jpg";